import React from 'react'
import { useHistory } from 'react-router-dom'
import { Result, Button } from 'antd'
const Error: React.FC = () => {
  const history = useHistory()
  return (
    <div
      style={{
        height: '100vh',
        top: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        left: 0,
        width: '100vw',
        background: 'white',
        position: 'absolute',
        zIndex: 999999999999,
      }}
    >
      <Result
        status="404"
        title=" Error 404"
        subTitle="Sorry, the page you visited does not exist."
        extra={
          <Button onClick={() => history.replace('/home')} type="primary">
            Back Home
          </Button>
        }
      />
    </div>
    // <Result
    //   status="success"
    //   title="Successfully Purchased Cloud Server ECS!"
    //   subTitle="Order number: 2017182818828182881 Cloud server configuration takes 1-5 minutes, please wait."
    //   extra={[
    //     <Button type="primary" key="console">
    //       Go Console
    //     </Button>,
    //     <Button key="buy">Buy Again</Button>,
    //   ]}
    // />
  )
}

export default Error
